import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'video_mng',
  props: {
    current: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '环境数据管理',
        addFunName: 'planEnvmtAdd',
        modifyFunName: 'planEnvmtModify',
        handleFunName: 'planEnvmtHandle',
        queryFunName: 'planEnvmtQuery',
        detailFunName: 'planEnvmtDetail',
        delFunName: 'planEnvmtDel'
      },
      searchForm: {
        page: 1,
        limit: 10,
        sortField: 'create_time'
      },
      formData: {
        planId: this.current.id
      },
      rules: {
        areaName: [{
          required: true,
          message: '请输入养殖池名称',
          trigger: 'blur'
        }],
        environmentContent: [{
          required: true,
          message: '请填写水质环境数据',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {},
      environmentContent: [],
      environmentContentFormData: {},
      environmentContentDialogShow: false,
      environmentContentRules: {
        label: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        value: [{
          required: true,
          message: '请输入数据',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  watch: {
    environmentContentDialogShow: function environmentContentDialogShow(to) {
      if (!to) {
        this.environmentContentFormData = {};
      }
    }
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      var environmentContent = paramData.environmentContent ? JSON.parse(paramData.environmentContent) : {};
      this.environmentContent = [];
      for (var key in environmentContent) {
        this.environmentContent.push({
          label: key,
          value: environmentContent[key]
        });
      }
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    back: function back() {
      this.$emit('child-go-plan');
    },
    add: function add() {
      this.initFormData(this.emptyFormData);
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this = this;
      this.$api[this.pageConfig.detailFunName](id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this.initFormData(res.data);
                _this.editDialogTitle = _this.pageConfig.editPageName + '维护';
                _this.editDialogShow = true;
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    envmtAdd: function envmtAdd() {
      this.index = -1;
      this.environmentContentDialogShow = true;
    },
    envmtDel: function envmtDel(index) {
      this.environmentContent.splice(index, 1);
    },
    envmtEdit: function envmtEdit(index) {
      this.index = index;
      this.environmentContentDialogShow = true;
    },
    submitEnvmtFormData: function submitEnvmtFormData() {
      var _this2 = this;
      this.$refs['environmentContentFormDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this2.index === -1) {
            _this2.environmentContent.push(_this2.environmentContentFormData);
          } else {
            _this2.environmentContent.splice(index, 1, _this2.environmentContentFormData);
          }
          _this2.environmentContentDialogShow = false;
        }
      });
    },
    del: function del(id) {
      var _this3 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this4 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.current.id, this.searchForm).then(function (res) {
        _this4.tableData = res.data || [];
        _this4.totalCount = res.count;
        _this4.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this5 = this;
      var environmentContent = {};
      var _iterator = _createForOfIteratorHelper(this.environmentContent),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          environmentContent[item.label] = item.value;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.formData.environmentContent = JSON.stringify(environmentContent);
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this5.formData.id) {
            _this5.$api[_this5.pageConfig.modifyFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('编辑成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('编辑失败');
              }
            });
          } else {
            _this5.$api[_this5.pageConfig.addFunName](_this5.saveFormDataProcess(_this5.formData)).then(function (res) {
              if (res.data) {
                _this5.$message.success('新增成功');
                _this5.initFormData(_this5.emptyFormData);
                _this5.editDialogShow = false;
                _this5.query();
              } else {
                _this5.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};